import { CSSProperties } from 'react'

export interface SpinnerProps {
    /** Размер спиннера в пикселях (по умолчанию 16) */
    size?: number
    /** Толщина линии в пикселях (по умолчанию 2) */
    strokeWidth?: number
    /** CSS класс для дополнительной стилизации */
    className?: string
    /** Inline стили */
    style?: CSSProperties
}

/**
 * Компактный спиннер для индикации загрузки
 * Использует CSS анимацию для вращения
 */
export const Spinner = ({
    size = 16,
    strokeWidth = 2,
    className,
    style,
}: SpinnerProps) => {
    const spinnerStyle: CSSProperties = {
        width: size,
        height: size,
        border: `${strokeWidth}px solid var(--gray, #e0e0e0)`,
        borderTop: `${strokeWidth}px solid var(--blue-primary, #3b82f6)`,
        borderRadius: '50%',
        animation: 'spinner-rotate 1s linear infinite',
        boxSizing: 'border-box',
        flexShrink: 0,
        ...style,
    }

    return (
        <>
            <style>
                {`
                    @keyframes spinner-rotate {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <div className={className} style={spinnerStyle} />
        </>
    )
}
